import React, { useContext, useEffect, useState } from "react";
import MenuButton from "../MenuButton/MenuButton";
import logo from "../../icons/logo.png";
import Swal from "sweetalert2";
import html2canvas from "html2canvas";
import UserServices from "../../UserServices/UserServices";
import { NoteState } from "../../context/notes/NoteState";
import { useParams } from "react-router";
import CurrencyFormat from "react-currency-format";
import "./SalarySlip.css";

function amountOf(value) {
  const amount = parseInt(value, 10);
  return Number.isFinite(amount) ? amount : 0;
}

function Money({ value }) {
  return (
    <CurrencyFormat
      value={amountOf(value)}
      displayType="text"
      thousandSpacing="2s"
      thousandSeparator={true}
      prefix="Rs "
      suffix="/-"
      renderText={(text) => <span>{text}</span>}
    />
  );
}

function formatDay(date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = String(date.getFullYear()).slice(-2);
  return `${day}-${month}-${year}`;
}

function padRows(rows, count) {
  const padded = rows.slice();
  while (padded.length < count) {
    padded.push(["-", null]);
  }
  return padded;
}

export default function SalarySlip() {
  const [loading, setLoading] = useState(false);
  const { state } = useContext(NoteState);
  const { branch_id } = state;
  const { id } = useParams();
  const [department, setDepartment] = useState("");
  const [name, setName] = useState("");
  const [branch, setBranch] = useState("");
  const [uid, setUid] = useState("");
  const [designation, setDesignation] = useState("");
  const [ptCommission, setPTCommission] = useState("");
  const [gxCommission, setGXCommission] = useState("");
  const [reward, setReward] = useState("");
  const [sptCommission, setSPTCommission] = useState("");
  const [cafe, setCafe] = useState("");
  const [medical, setMedical] = useState("");
  const [salary, setSalary] = useState("");
  const [detections, setDetections] = useState("");
  const [commission, setCommission] = useState("");
  const [advance, setAdvance] = useState("");
  const [fine, setFine] = useState("");
  const [loans, setLoans] = useState("");
  const [componentAddition, setComponentAddition] = useState(0);
  const [componentDeduction, setComponentDeduction] = useState(0);
  const [joining, setJoining] = useState("");
  const [salaryDate, setSalaryDate] = useState("");
  const [salaryMonth, setSalaryMonth] = useState("");
  const [salaryComponents, setSalaryComponents] = useState([]);

  const currentDate = new Date();
  currentDate.setDate(1);
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const formattedMonth = month < 10 ? `0${month}` : month;

  const getMonthName = (monthNumber) => {
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    return monthNames[parseInt(monthNumber, 10) - 1];
  };

  const downloadImage = async (blob) => {
    const div = window.document.createElement("div");
    div.style = "display:none; text-align:center;";
    const myImage = window.document.createElement("img");
    myImage.src = blob;
    myImage.style = "display:block; margin:0 auto;";
    div.appendChild(myImage);
    setLoading(false);
    const printArea = window.open();
    if (printArea && printArea.document) {
      printArea.document.write(div.innerHTML);
      printArea.document.close();
      printArea.focus();
      printArea.print();
      printArea.close();
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to open print window",
      });
    }
  };

  const printSlip = async (el) => {
    setLoading(true);
    const canvas = await html2canvas(el, { scale: 3, backgroundColor: "#ffffff" });
    downloadImage(canvas.toDataURL("image/jpeg", 0.95));
  };

  const getSalary = async () => {
    setLoading(true);
    try {
      const responce = await UserServices.getLatestStaffSalarySlip(
        branch_id,
        formattedMonth,
        year,
        id
      );
      if (responce.status === 200) {
        const data = responce.data.data;
        data.map((value) => {
          setName(value.name);
          setDepartment(value.department);
          setBranch(value.branch);
          setUid(value.uid);
          setDesignation(value.designation);
          setPTCommission(parseInt(value.commission?.pt_commission, 10));
          setGXCommission(parseInt(value.commission?.gx_commission, 10));
          setReward(value.reward);
          setSPTCommission(parseInt(value.commission?.small_pt_commission, 10));
          setCommission(parseInt(value.commission?.commission, 10));
          setCafe(value.cafe);
          setMedical(value.medical);
          setSalary(value.salary);
          setDetections(value.detections);
          setAdvance(parseInt(value.advance, 10) || 0);
          setFine(parseInt(value.fine, 10) || 0);
          setLoans(parseInt(value.loan, 10) || 0);
          setComponentAddition(parseInt(value.components_addition, 10) || 0);
          setComponentDeduction(parseInt(value.components_deduction, 10) || 0);
          setSalaryComponents(value.salary_components || []);
          setSalaryDate(`01-${formattedMonth}-${year}`);
          setSalaryMonth(getMonthName(formattedMonth));
          setJoining(value.joining);
          return null;
        });
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    getSalary();
  }, []);

  const calculateFirstMonthSalary = (joiningDate, packageSalary) => {
    const joiningDateObj = new Date(joiningDate);

    if (
      joiningDateObj.getFullYear() === parseInt(year, 10) &&
      joiningDateObj.getMonth() + 1 === parseInt(formattedMonth, 10)
    ) {
      const daysInMonth = new Date(
        joiningDateObj.getFullYear(),
        joiningDateObj.getMonth() + 1,
        0
      ).getDate();
      const remainingDays = daysInMonth - joiningDateObj.getDate() + 1;
      const dailySalary = packageSalary / daysInMonth;
      return (dailySalary * remainingDays).toFixed(0);
    } else if (parseInt(year, 10) > joiningDateObj.getFullYear()) {
      return Number(packageSalary).toFixed(0);
    } else if (
      joiningDateObj.getFullYear() === parseInt(year, 10) &&
      parseInt(formattedMonth, 10) >= joiningDateObj.getMonth() + 1
    ) {
      return packageSalary;
    }
    return 0;
  };

  const payable = amountOf(calculateFirstMonthSalary(joining, salary));
  const commissionParts =
    amountOf(ptCommission) + amountOf(gxCommission) + amountOf(sptCommission);
  const additions = salaryComponents.filter((item) => item.type === "addition");
  const deductionItems = salaryComponents.filter((item) => item.type === "deduction");
  const additionGap =
    amountOf(componentAddition) -
    additions.reduce((sum, item) => sum + amountOf(item.amount), 0);
  const deductionGap =
    amountOf(componentDeduction) -
    deductionItems.reduce((sum, item) => sum + amountOf(item.amount), 0);

  const earnings = [
    ["Monthly salary", payable],
    ["PT Commission", ptCommission],
    ["GX Commission", gxCommission],
    ["SPT Commission", sptCommission],
  ];
  if (amountOf(commission) !== commissionParts) {
    earnings.push(["Commission", amountOf(commission) - commissionParts]);
  }
  earnings.push(["Reward", reward]);
  additions.forEach((item) => earnings.push([item.component_name, item.amount]));
  if (additionGap) earnings.push(["Other addition", additionGap]);

  const deductions = [
    ["Advance", advance],
    ["Penalty", fine],
    ["Loan installment", loans],
    ["Deductions", detections],
    ["Cafe", cafe],
    ["Medical", medical],
  ];
  deductionItems.forEach((item) => deductions.push([item.component_name, item.amount]));
  if (deductionGap) deductions.push(["Other deduction", deductionGap]);

  const rowCount = Math.max(earnings.length, deductions.length, 8);
  const earningRows = padRows(earnings, rowCount);
  const deductionRows = padRows(deductions, rowCount);

  const gross =
    payable + amountOf(commission) + amountOf(componentAddition) + amountOf(reward);
  const deductionTotal =
    amountOf(advance) +
    amountOf(fine) +
    amountOf(cafe) +
    amountOf(detections) +
    amountOf(loans) +
    amountOf(medical) +
    amountOf(componentDeduction);
  const net = gross - deductionTotal;

  const periodEnd = new Date(parseInt(year, 10), parseInt(formattedMonth, 10) - 1, 25);
  const periodStart = new Date(periodEnd.getFullYear(), periodEnd.getMonth() - 1, 26);
  const joiningDate = joining ? new Date(joining) : null;
  const joiningText =
    joiningDate && !Number.isNaN(joiningDate.getTime()) ? formatDay(joiningDate) : "-";

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <MenuButton />
          <div className="card">
            <div className="card-header py-3">
              <h5 className="mb-0 font-20">
                Salary slip
                <button
                  className="btn btn-danger d-inline-block ms-2 me-2 btn-sm"
                  onClick={() => printSlip(document.getElementById("invoice-POS"))}
                >
                  <i className="bi bi-printer-fill"></i>
                </button>
              </h5>
            </div>
            <div className="card-body">
              <div className="ps-sheet" id="invoice-POS">
                <div className="ps-head">
                  <img src={logo} alt="Vostro World" />
                  <div>
                    <h2>SALARY SLIP</h2>
                    <p>{salaryMonth} {year}</p>
                  </div>
                </div>

                <table className="ps-table">
                  <tbody>
                    <tr>
                      <th>Employee name</th>
                      <td>{name || "-"}</td>
                      <th>Employee ID</th>
                      <td>{uid || "-"}</td>
                    </tr>
                    <tr>
                      <th>Department</th>
                      <td>{department || "-"}</td>
                      <th>Position</th>
                      <td>{designation || "-"}</td>
                    </tr>
                    <tr>
                      <th>Branch</th>
                      <td>{branch || "-"}</td>
                      <th>Month</th>
                      <td>{salaryMonth || "-"}</td>
                    </tr>
                    <tr>
                      <th>Pay period</th>
                      <td>{formatDay(periodStart)} to {formatDay(periodEnd)}</td>
                      <th>Slip date</th>
                      <td>{salaryDate || "-"}</td>
                    </tr>
                    <tr>
                      <th>Date of joining</th>
                      <td>{joiningText}</td>
                      <th>Pay date</th>
                      <td>{salaryDate || "-"}</td>
                    </tr>
                  </tbody>
                </table>

                <div className="ps-split">
                  <table className="ps-table">
                    <thead>
                      <tr className="ps-section">
                        <td colSpan="2">Gross earning</td>
                      </tr>
                      <tr>
                        <th>Description</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {earningRows.map((row, index) => (
                        <tr key={`earn-${index}`} className={index % 2 ? "ps-shade" : ""}>
                          <td>{row[0]}</td>
                          <td className="ps-amt">{row[1] === null ? "-" : <Money value={row[1]} />}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <table className="ps-table">
                    <thead>
                      <tr className="ps-section">
                        <td colSpan="2">Deduction</td>
                      </tr>
                      <tr>
                        <th>Description</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deductionRows.map((row, index) => (
                        <tr key={`deduct-${index}`} className={index % 2 ? "ps-shade" : ""}>
                          <td>{row[0]}</td>
                          <td className="ps-amt">{row[1] === null ? "-" : <Money value={row[1]} />}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="ps-foot">
                  <div className="ps-foot-note">
                    <img src={logo} alt="" />
                    <span>This is a computer-generated salary slip and does not require a signature or stamp.</span>
                  </div>
                  <div className="ps-total-box">
                    <span>Gross pay</span>
                    <strong><Money value={gross} /></strong>
                  </div>
                  <div className="ps-total-box">
                    <span>Deductions</span>
                    <strong><Money value={deductionTotal} /></strong>
                  </div>
                  <div className="ps-total-box ps-net">
                    <span>Net pay</span>
                    <strong><Money value={net} /></strong>
                  </div>
                </div>
                <p className="ps-disclaimer">www.vostroworld.com</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
}
